import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TArticleMeasureUnitDM from './TArticleMeasureUnitDM'
import TArticleDM from './TArticleDM'
import TPriceListDM from './TPriceListDM'
import TPriceListCalculationDM from './TPriceListCalculationDM'

/**
 * Ceníky - přímé zadávání
 */
export default class TPriceListItemDirectInputDM extends Data {
	public static className = 'TPriceListItemDirectInputDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Časové razítko
	 */
	TimeStamp?: string

	/**
	 * Kniha
	 */
	PriceListBookId?: number

	/**
	 * Platnost do
	 */
	ValidToDate?: Date

	/**
	 * Platnost od
	 */
	ValidFromDate?: Date

	/**
	 * Pouze pro násobek množství
	 */
	IsOnlyForMultipleOfQuantity?: string

	/**
	 * Kurz
	 */
	ExchangeRate?: number

	/**
	 * Editováno
	 */
	IsEdited?: string

	/**
	 * Položku ceníku uplatnit pouze při prodeji v zadané jednotce
	 */
	IsOnlyForMeasureUnit?: string

	/**
	 * Neaplikovat další slevy
	 */
	IsFinalPrice?: string

	/**
	 * Brutto
	 */
	PriceGross?: number

	/**
	 * Původní cena
	 */
	OriginalPriceNet?: number

	/**
	 * Definice výpočtu
	 */
	DefinitionRID?: number

	/**
	 * Netto
	 */
	PriceNet?: number

	/**
	 * Množství
	 */
	Quantity?: number

	/**
	 * Název
	 */
	ItemName?: string

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * undefined
	 */
	IsFictive?: string

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * undefined
	 */
	IsByDefinitionCalc?: string

	/**
	 * undefined
	 */
	VATCoefficientCalc?: number

	/**
	 * undefined
	 */
	CurrencyCodeCalc?: string

	/**
	 * Jednotka
	 */
	@Type(() => TArticleMeasureUnitDM)
	MeasureUnitId?: TArticleMeasureUnitDM

	/**
	 * Zboží
	 */
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM

	/**
	 * Ceník
	 */
	@Type(() => TPriceListDM)
	PriceListRID?: TPriceListDM

	/**
	 * Průběh výpočtu ceny
	 */
	@Type(() => TPriceListCalculationDM)
	PriceCalculationChild?: TPriceListCalculationDM[]
}